import { logger } from '@gem/modules/logger';

import { STREAM_STATUS } from 'APP/constants/stream';
import Entities from 'STORE';

// Needs Bff implementation
export default async () => {
  try {
    const response = { viewersTotal: 0 };

    Entities.ActiveStream.stream.updateStream({
      totalViewers: response.viewersTotal,
      status: STREAM_STATUS.FINISHED,
    });

    return response;
  } catch (e) {
    logger.get('API').error('streams.startStream', e);
    return null;
  }
};
